module.exports = __webpack_public_path__ + "ac65416c2166d8d41b69892808582d57.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-22.png
// module id = 3068
// module chunks = 0